var map = {
	"./alltactions": 9,
	"./alltactions.js": 9,
	"./customers": 22,
	"./customers.js": 22,
	"./customers/age": 3,
	"./customers/age.js": 3,
	"./customers/geo": 10,
	"./customers/geo.js": 10,
	"./customers/information": 23,
	"./customers/information.js": 23,
	"./customers/money": 11,
	"./customers/money.js": 11,
	"./customers/paymenthistory": 12,
	"./customers/paymenthistory.js": 12,
	"./customers/positions": 4,
	"./customers/positions.js": 4,
	"./customers/statistics": 24,
	"./customers/statistics.js": 24,
	"./customers/tags": 13,
	"./customers/tags.js": 13,
	"./dates": 5,
	"./dates.js": 5,
	"./demos": 25,
	"./demos.js": 25,
	"./menu": 6,
	"./menu.js": 6,
	"./notifications": 8,
	"./notifications.js": 8,
	"./payhistoryview": 26,
	"./payhistoryview.js": 26,
	"./persons": 2,
	"./persons.js": 2,
	"./prices": 27,
	"./prices.js": 27,
	"./settings": 38,
	"./settings.js": 38,
	"./toolbar": 7,
	"./toolbar.js": 7,
	"./top": 28,
	"./top.js": 28,
	"./transactions": 29,
	"./transactions.js": 29,
	"./tutorials": 30,
	"./tutorials.js": 30,
	"./widgets": 31,
	"./widgets.js": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;